import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { Button, Form, InputGroup } from "react-bootstrap";
import VideoUploader from "./VideoUploader";
import { DeleteIcon, FilterCollapseIcon, FilterTwoIcon } from "../Icons";
import CachedIcon from "mdi-react/CachedIcon";
import queryString from "query-string";
import { useQuery } from "react-query";
import { useQueryParams } from "../../utils/hooks";
import { paginationOptions } from "../../utils/helpers";
import ConfirmDialog from "../ConfirmDialogue";
import { description } from "platform";

const VideoList = () => {
  const [videos, setVideos] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [page, setPage] = useState(1);
  const [allCategories, setCategories] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [showUploadVideoModal, setShowUploadVideoModal] = useState(false);
  const { backendUrl, token, user } = useAuth();
  const [showFilter, setShowFilter] = useState(true);
  const initialFilterParams = {
    search,
    category,
    page,
    limit: 40,
  };
  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  // const fetchVideos = async () => {
  //   // const params = new URLSearchParams({
  //   //   search,
  //   //   category,
  //   //   page,
  //   //   limit: 6,
  //   // });
  //   try {
  //     const res = await fetch(
  //       `${backendUrl}/api/invex-knowledgebase/videos?${params.toString()}`
  //     );
  //     const { data, pagination, categories } = await res.json();
  //     setVideos(data || []);
  //     setTotalPages(pagination?.totalPages || 1);
  //     setCategories(categories);
  //   } catch (error) {
  //     console.error("Error fetching videos:", error);
  //   }
  // };

  const fetchAllVideos = async (query) => {
    const res = await fetch(
      `${backendUrl}/api/invex-knowledgebase/videos?${queryString.stringify(
        query
      )}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      }
    );

    const data = await res.json();

    return data;
  };

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["KNOWLEDGEBASE_VIDEOS", queryParams],
    () => fetchAllVideos(queryParams),

    {
      enabled: true,
      keepPreviousData: true,
    }
  );
  useEffect(() => {
    console.log(data);
    setVideos(data?.data || []);
    setTotalPages(data?.pagination?.totalPages || 1);
    setCategories(data?.categories || []);
  }, [data]);

  const handleSearchQueryChange = (input) => {
    setQueryParams({
      ...queryParams,
      ...input,
    });
  };

  const handleDeleteVideo = async (video) => {
    if (
      await ConfirmDialog({
        description: `Are you sure you want to delete video "${video.title}"`,
      })
    ) {
      console.log("Deleting video");
    }
  };

  return (
    <main className="cash-book knowledgebase">
      <div className="content ">
        <div className="content-main pt-3">
          <VideoUploader
            show={showUploadVideoModal}
            handleClose={() => setShowUploadVideoModal(false)}
            categories={allCategories}
            refetch={refetch}
          />
          <div className={`filter-area ${showFilter ? "open" : "close"}`}>
            <div className="filter-header">
              <h2>
                <FilterTwoIcon /> Filters
              </h2>

              <Button
                variant="white"
                onClick={() => setShowFilter(!showFilter)}
              >
                <FilterCollapseIcon />
              </Button>
            </div>
            <div className="filter-body">
              <Form onSubmit={(e) => e.preventDefault()}>
                <div className="body">
                  <Form.Group className="mb-3 pb-2 mb-2-5">
                    <Form.Label>Name</Form.Label>{" "}
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Search videos..."
                        className="form-control"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            handleSearchQueryChange({ search });
                            setPage(1);
                          }
                        }}
                      />{" "}
                    </InputGroup>
                  </Form.Group>
                  <Form.Group className="mb-3 pb-2 mb-2-5">
                    <Form.Label>Category</Form.Label>{" "}
                    <select
                      className="form-control"
                      value={category}
                      onChange={(e) => {
                        setCategory(e.target.value);
                        handleSearchQueryChange({ category: e.target.value });
                        setPage(1);
                      }}
                    >
                      <option value="">All Categories</option>
                      {allCategories.map((cat, index) => (
                        <option key={index} value={cat}>
                          {cat.charAt(0).toUpperCase() + cat.slice(1)}
                        </option>
                      ))}
                    </select>
                  </Form.Group>

                  {/* <Form.Group className="mb-3 pb-2 mb-2-5">
                      <Form.Label>Branch</Form.Label>{" "}
                      <InputGroup>
                        <Form.Control
                          name="branch"
                          value={filterParams.branch}
                          placeholder="branch name"
                          onChange={(e) => handleFilterParamsChange(e)}
                        />{" "}
                      </InputGroup>
                    </Form.Group> */}

                  <hr className="mt-3 mb-4" />
                </div>

                <div className="buttons rounded">
                  <Button
                    onClick={() => {
                      handleSearchQueryChange({ search: "", category: "" });
                      setSearch("");
                      setCategory("");
                      setPage(1);
                    }}
                    variant="white"
                  >
                    Reset
                  </Button>
                  <Button
                    onClick={() => {
                      handleSearchQueryChange({ search });
                      setPage(1);
                    }}
                    variant="primary"
                  >
                    Search
                  </Button>
                </div>
              </Form>
            </div>
          </div>
          <div className="content-body">
            <header>
              <h1>
                {!showFilter && (
                  <button
                    onClick={() => setShowFilter(!showFilter)}
                    className="btn filter"
                  >
                    <FilterTwoIcon />
                  </button>
                )}
                Invex knowledgebase videos
                <button
                  title="Refresh"
                  className="btn text-primary"
                  onClick={() => refetch()}
                >
                  <CachedIcon />
                </button>
              </h1>
              <div className="actions">
                <Button
                  variant="primary"
                  onClick={() => {
                    setShowUploadVideoModal(true);
                  }}
                >
                  + Upload new video
                </Button>
              </div>
            </header>

            {/* <div className="container mt-4"> */}
            {/* <h2 className="mb-3">Invexerp Knowledge Base</h2> */}

            {/* <div className="row mb-4">
              <div className="col-md-6 mb-2">
                <input
                  type="text"
                  placeholder="Search videos..."
                  className="form-control"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                  }}
                />
              </div>
              <div className="col-md-6 mb-2">
                <select
                  className="form-control"
                  value={category}
                  onChange={(e) => {
                    setCategory(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">All Categories</option>
                  {categories.map((cat, index) => (
                    <option key={index} value={cat}>
                      {cat.charAt(0).toUpperCase() + cat.slice(1)}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}

            <div className="row p-4">
              {videos.map((video) => (
                <div key={video.id} className="video-item col-md-4 mb-4">
                  <div className="card h-100">
                    <img
                      src={video.thumbnail}
                      className="card-img-top"
                      alt={video.name}
                      loading="lazy"
                    />
                    <div className="card-body d-grid w-full align-self-end">
                      <h5 className="card-title">
                        {video.title}{" "}
                        {user.Staff_ID === video.uploader_id && (
                          <span
                            onClick={() => handleDeleteVideo(video)}
                            className="deleteIcon"
                          >
                            <DeleteIcon color="red" />
                          </span>
                        )}
                      </h5>
                      <p className="card-text">{video.description}</p>
                      <p className="text-muted mb-1">
                        <small>Category: {video.category}</small>
                      </p>
                      <a
                        href={video.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary btn-sm"
                      >
                        Watch Video
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* </div> */}

            <div className="d-flex justify-content-end px-3 align-items-center pagination w-[80%] absolute buttom-0">
              {/* <div className="pagination_left">
                <p className="m-0 p-0">Show</p>
                <select
                  value={queryParams.limit}
                  name="limit"
                  className="form-select "
                  onChange={(e) => handleSearchQueryChange(e)}
                >
                  <option value="10">10 rows</option>
                  <option value="20">20 rows</option>
                  <option value="30">30 rows</option>
                  <option value="40">40 rows</option>
                  <option value="50">50 rows</option>
                  <option value="100">100 rows</option>{" "}
                </select>
              </div> */}

              {/* <nav>
                <ul className="pagination justify-content-center">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (pg) => (
                      <li
                        key={pg}
                        className={`page-item ${pg === page ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setPage(pg)}
                        >
                          {pg}
                        </button>
                      </li>
                    )
                  )}
                </ul>
              </nav> */}
            </div>
          </div>
        </div>
      </div>
    </main>
  );

  // return (
  //   <div className="container mt-4">
  //     <h2 className="mb-3">Invexerp Knowledge Base</h2>

  //     <div className="row mb-4">
  //       <div className="col-md-6 mb-2">
  //         <input
  //           type="text"
  //           placeholder="Search videos..."
  //           className="form-control"
  //           value={search}
  //           onChange={(e) => {
  //             setSearch(e.target.value);
  //             setPage(1);
  //           }}
  //         />
  //       </div>
  //       <div className="col-md-6 mb-2">
  //         <select
  //           className="form-control"
  //           value={category}
  //           onChange={(e) => {
  //             setCategory(e.target.value);
  //             setPage(1);
  //           }}
  //         >
  //           <option value="">All Categories</option>
  //           {categories.map((cat, index) => (
  //             <option key={index} value={cat}>
  //               {cat.charAt(0).toUpperCase() + cat.slice(1)}
  //             </option>
  //           ))}
  //         </select>
  //       </div>
  //     </div>

  //     <div className="row">
  //       {videos.map((video) => (
  //         <div key={video.id} className="col-md-4 mb-4">
  //           <div className="card h-100">
  //             <img
  //               src={video.thumbnail_url}
  //               className="card-img-top"
  //               alt={video.name}
  //               loading="lazy"
  //             />
  //             <div className="card-body">
  //               <h5 className="card-title">{video.name}</h5>
  //               <p className="card-text">{video.description}</p>
  //               <p className="text-muted mb-1">
  //                 <small>Category: {video.category}</small>
  //               </p>
  //               <a
  //                 href={video.video_url}
  //                 target="_blank"
  //                 rel="noopener noreferrer"
  //                 className="btn btn-primary btn-sm"
  //               >
  //                 Watch Video
  //               </a>
  //             </div>
  //           </div>
  //         </div>
  //       ))}
  //     </div>

  //     <nav>
  //       <ul className="pagination justify-content-center">
  //         {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
  //           <li key={pg} className={`page-item ${pg === page ? "active" : ""}`}>
  //             <button className="page-link" onClick={() => setPage(pg)}>
  //               {pg}
  //             </button>
  //           </li>
  //         ))}
  //       </ul>
  //     </nav>
  //     <Button onClick={() => setShowUploadVideoModal(true)}>
  //       Upload Video
  //     </Button>
  //     <VideoUploader
  //       show={showUploadVideoModal}
  //       handleClose={() => setShowUploadVideoModal(false)}
  //       categories={categories}
  //     />
  //   </div>
  // );
};

export default VideoList;
